//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Action, Container, Typography } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import loadExistingAbTests from '@abTests/util'
import authenticate from '@auth/util'
import Error4XX from '@core/pages/errors/4XX'
import Error500 from '@core/pages/errors/500'
import { ROUTES } from '@router'
import { trackError } from '@tracking/events'

import translations from './error.translations'

export default {
  components: {
    Action,
    Container,
    Typography,
  },
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  head() {
    const { statusCode, path } = this.error

    return {
      htmlAttrs: {
        lang: this.locale,
      },
      title: statusCode,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${statusCode} | ${path}`,
        },
      ],
    }
  },
  computed: {
    ...mapGetters({ locale: 'config/locale' }),
    ROUTES: () => ROUTES,
    translations: () => translations,
    is404or410() {
      return this.error.statusCode === 404 || this.error.statusCode === 410
    },
    component() {
      if (this.is404or410) {
        return Error4XX
      }

      return Error500
    },
  },

  beforeMount() {
    authenticate({
      store: this.$store,
      config: this.$config,
    })
  },

  mounted() {
    loadExistingAbTests({ $abTests: this.$abTests })

    trackError({ status: this.error.statusCode, message: this.error.message })
  },
}
